module.exports = __webpack_public_path__ + "media/images/top/img_pickup_waizu-a076f48bcd73d34b852eb94cf0477db9.webp";